import ArgumentException from '../Exceptions/ArgumentException';
import ArgumentNullException from '../Exceptions/ArgumentNullException';
import ArgumentUndefinedException from '../Exceptions/ArgumentUndefinedException';
import SR from '../i18n/en/assertions.strings.json';
import { format } from '../Strings';
/**
 * Instance of @see IArgumentAssertionBuilder<T>
 */
export default class ArgumentAssertionBuilder {
    constructor(argument, argumentName) {
        this.argument = argument;
        this.argumentName = argumentName;
    }
    /** Ensures the argument is not null or undefined */
    isNotNullOrUndefined() {
        return this.isNotNull().isNotUndefined();
    }
    /** Ensures the argument is not null */
    isNotNull() {
        if (this.argument == null) {
            throw new ArgumentNullException(this.argumentName);
        }
        return this;
    }
    /** Ensures the argument is not undefined */
    isNotUndefined() {
        if (this.argument === undefined) {
            throw new ArgumentUndefinedException(this.argumentName);
        }
        return this;
    }
    /**
     * Ensures the argument is of the type
     * @param type The type
     */
    isTypeOf(type) {
        if (!(this.argument instanceof type)) {
            throw new ArgumentException(this.argumentName, format(SR.isTypeOfExceptionMessage, this.argumentName, type));
        }
        return this;
    }
    /**
     * Asserts on the value of predicate to whether the assertion is valid.
     * @param predicate The predicate to test to see if the assertion is valid.
     * @param message The message to use if the assertion is invalid.
     */
    matches(predicate, message) {
        let result;
        let innerException;
        try {
            result = predicate(this.argument);
        }
        catch (ex) {
            innerException = ex;
            result = false;
        }
        if (!result) {
            throw new ArgumentException(this.argumentName, message, innerException);
        }
        return this;
    }
    /**
     * Determines whether the argument is one of the specified options.
     * @param options
     */
    isOneOf(...options) {
        if (options.indexOf(this.argument) == -1) {
            throw new ArgumentException(this.argumentName, format(SR.isOneOfExceptionMessage, this.argumentName, options.join("', '")));
        }
        return this;
    }
}
